export default "__VITE_ASSET__DxDK3Jne__"